/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_menu = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	this.onready = function() {

		/*
		Header: Buttons Map en Menu
		Header: Buttons Map en Menu
		Header: Buttons Map en Menu
		Header: Buttons Map en Menu
		*/
		$(document).on('click','.js-button-map',function() {
			
			if(
				$('.js-button-map').hasClass('closed')
			) {
				_action = 'open';
			} else {
				_action = 'close';
			}

			specific_menu.openAndClose('map',_action);

		});

		$(document).on('click','.js-button-menu',function() {
			
			if(
				$('.js-button-menu').hasClass('closed')
			) {
				_action = 'open';
			} else {
				_action = 'close';
			}

			specific_menu.openAndClose('menu',_action);

		});

		/*
		Floorbutton: Menu
		Floorbutton: Menu
		Floorbutton: Menu
		Floorbutton: Menu
		*/
		$(document).on('click','.menu .js-floor-button',function() {

			var _w = $(this).data('floor');

			specific_menu.openMenuFloor(_w);

		});

			/*
			Scenebutton
			*/
			$(document).on('click','.js-scene-button',function() {

				var _w = $(this).data('scene');

				// if(
				// 	_w == 'rtm-stage-1' ||
				// 	_w == 'rtm-stage-2' ||
				// 	_w == 'rtm-stage-3'
				// ) {
				// 	_w = 'rtm-stage';
				// }

				specific_menu.gotoScene(_w);

			});

		/*
		Floorbutton: Map
		Floorbutton: Map
		Floorbutton: Map
		Floorbutton: Map
		*/
		$(document).on('click','.map .js-floor-button',function() {

			var _w = $(this).data('floor');

			specific_menu.openMapFloor(_w);			

		});

			/*
			Scenebutton
			*/
			$(document).on('click','.js-floorplan-button',function() {

				var _w = $(this).data('scene');

				// /*
				// Reset to RTM Stage
				// */
				// if(
				// 	_w == 'rtm-stage-1' ||
				// 	_w == 'rtm-stage-2' ||
				// 	_w == 'rtm-stage-3'
				// ) {
				// 	_w = 'rtm-stage';
				// }

				specific_menu.gotoScene(_w);

			});
		
	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	this.setMapAndFloorInMenu = function() {

		/*
		Check URL's
		*/
		var _selected_floor 	= url[1];
		var _selected_room 		= url[2];

		$('.titles').show();

		/*
		Overrule
		*/
		switch(_selected_room) {

			default:
			break;

			/*
			Lower ground floor *********************************
			Lower ground floor *********************************
			Lower ground floor *********************************
			Lower ground floor *********************************
			*/

			case '6':
				_selected_room = '5';
			break;

		}

		/*
		Floor
		*/
		$('.js-floor').removeClass('active');
		$('.js-floor-button').removeClass('active');

		$('.js-floorplan').removeClass('active');
		$('.js-floorplan-button').removeClass('active');

		/*
		Menu: Active
		*/
		$('.js-scene-button').removeClass('active');
		$('.js-scene-button[data-scene="' + _selected_floor + '/' + _selected_room + '"]').addClass('active');

		/*
		Map: Active
		*/

		$('.js-floorplan-button').removeClass('active');

		// if(
		// 	_w == 'rtm-stage'
		// ) {
		// 	$('.js-floorplan-button[data-scene="rtm-stage-1"]').addClass('active');
		// 	$('.js-floorplan-button[data-scene="rtm-stage-2"]').addClass('active');
		// 	$('.js-floorplan-button[data-scene="rtm-stage-3"]').addClass('active');
		// } else {
		// 	$('.js-floorplan-button[data-scene="' + _w + '"]').addClass('active');
		// }

		/*
		Set: Active
		*/
		$('.js-floorplan-button[data-scene="' + _selected_floor + '/' + _selected_room + '"]').addClass('active');

		/*
		Set: Title
		*/
		_selected_title = $('.js-scene-button.active').text();
		$('.js-maps').find('h3').text(_selected_title);

		/*
		Set: Floor
		*/
		$('.js-floor-' + _selected_floor).addClass('active');
		$('.js-floor-button-' + _selected_floor).addClass('active');

		$('.js-floorplan-' + _selected_floor).addClass('active');
		$('.js-floorplan-button-' + _selected_floor).addClass('active');

		$('.js-mapssmall').addClass('floor-' + _selected_floor);
		
	};

	this.openAndClose = function(w,_action) {

		/*
		Close all overlay
		*/
		$('.js-button-map').addClass('closed');
		$('.js-button-map').find('.icon').removeClass('close');
		$('.js-overlay-map').hide();

		$('.js-button-menu').addClass('closed');
		$('.js-button-menu').find('.icon').removeClass('close');
		$('.js-overlay-menu').hide();

		$('.js-overlay').hide();

		$('.js-overlay').removeClass('menu map');

		/*
		Open or close?
		*/
		if(_action == 'open') { 
	
			$('.js-button-' + w).removeClass('closed');
			$('.js-button-' + w).find('.icon').addClass('close');
			$('.js-overlay-' + w).show();

			$('.js-overlay').addClass(w);

			$('.js-overlay').fadeIn(300);

		}

	};

	/*
	Scene: Go to
	*/
	this.gotoScene = function(w) {

		$('.overlay').fadeOut(300);

		specific_360.updateUrl(w);

		specific_menu.openAndClose('menu','close');
		specific_menu.openAndClose('map','close');

	};

	/*
	Floor: Show scenes
	*/
	this.openMenuFloor = function(w) {

		$('.menu .js-floor').hide();
		$('.menu .js-floor-button').removeClass('active');

		$('.menu .js-floor-button-' + w).addClass('active');
		$('.menu .js-floor-' + w).show();

		$('.js-scenes').animate({ scrollTop: 0 }, 0);

	};

	/*
	Map: Show floorplans
	*/
	this.openMapFloor = function(w) {

		$('.map .js-floorplan').hide();
		$('.map .js-floor-button').removeClass('active');

		$('.map .js-floor-button-' + w).addClass('active');
		$('.map .js-floorplan-' + w).show();

		$('.js-maps').animate({ scrollTop: 0 }, 0);

	};

		
}).apply(specific_menu); 